import styled from "styled-components";

const FormContainer = styled.div.attrs({
  className: "w-full flex flex-col gap-4 mt-6",
})``;

const TwoThirdWidth = styled.div.attrs({
  className: "sm:w-full md:w-9/12 flex flex-col gap-4",
})``;

const HalfWidth = styled.div.attrs({
  className: "sm:w-full md:w-6/12 flex flex-col gap-4",
})``;

const UploadContainer = styled.div.attrs({
  className:
    "ml-auto mt-9 mb-5 flex gap-4 content-center cursor-pointer items-center hover:text-black",
})``;

const Footer = styled.div.attrs({
  className:
    "w-fit ml-auto flex gap-5 content-center items-center hover:text-black",
})``;

export default {
  FormContainer,
  TwoThirdWidth,
  HalfWidth,
  UploadContainer,
  Footer,
};
